<ng-container *ngIf="(icapLog$ | async) as icapLog">
    <log-cinematic-sub-section-wrapper
        [header]="l10nKeys.icapLabel | vtranslate: (icapLog.action ? 1 : 0) : totalNumberOfIcapViolations"
    >
        <log-cinematic-sub-section-icap></log-cinematic-sub-section-icap>
    </log-cinematic-sub-section-wrapper>
</ng-container>

<log-cinematic-sub-section-wrapper
    [header]="l10nKeys.wafLabel | vtranslate"
    *ngIf="wafLog$ | async"
>
    <log-cinematic-section-security-waf></log-cinematic-section-security-waf>
</log-cinematic-sub-section-wrapper>

<log-cinematic-sub-section-wrapper
    [header]="globalL10nKeys.botLabel | vtranslate"
    *ngIf="botManagementLog$ | async"
>
    <log-cinematic-section-security-bot></log-cinematic-section-security-bot>
</log-cinematic-sub-section-wrapper>
